module.exports = __webpack_public_path__ + "static/media/saved_anchorage_marker.de6eb68d.svg";